export default __webpack_public_path__ + "5370a3aab265e9f47d504eb09b53c6a8.svg";